import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VipSettingsComponent } from './settings/vip-settings.component';
import { AllVipsComponent } from './all-vips/all-vips.component';
import { VipSettingsEditDialogComponent } from './settings/dialogs/vip-settings-edit.component';
import { VipEditDialogComponent } from './all-vips/dialogs/vip-edit.component';
import { VipMemberLogsComponent } from './vipmemberlogs/vip-member-logs.component';
import { VipContentSettingsComponent } from './vip-content-settings/vip-content-settings.component';
import { VipFooterSettingsComponent } from './vip-footer-settings/vip-footer-settings.component';
import { AppPermissionKeys } from '@core/models/app-permissions.model';

const routes: Routes = [
  {
    path: 'all-vips',
    component: AllVipsComponent,
    data: { title: '13.1 All VIPs', permissions: AppPermissionKeys.view_all_vips_list }
  },
  {
    path: 'settings',
    component: VipSettingsComponent,
    data: { title: '13.2 VIP Settings', permissions: AppPermissionKeys.view_vip_settings_list }
  },
  {
    path: 'vipmemberlogs',
    component: VipMemberLogsComponent,
    data: { title: '13.3 VIP Member Logs', permissions: AppPermissionKeys.view_vip_member_logs_list }
  },
  {
    path: 'vip-content-settings',
    component: VipContentSettingsComponent,
    data: { title: '13.4 VIP Content Settings', permissions: AppPermissionKeys.view_vip_structure_section }
  },
  {
    path: 'vip-footer-settings',
    component: VipFooterSettingsComponent,
    data: { title: '13.5 VIP Footer Settings', permissions: AppPermissionKeys.view_vip_footer_section }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  entryComponents: [
    VipSettingsEditDialogComponent,
    VipEditDialogComponent
  ]
})
export class VipRoutingModule { }
